<template>
  <div>
    <!-- Compact identity strip for the admin drill-down: who this agenda
         belongs to and whether families can book them. The full checklist,
         bio, and new-client link live on the command center card and the
         drawer — this page's job is the calendar, not setup state. -->
    <div class="flex align-items-center gap-sm">
      <img v-if="hasPhoto(coachData)" :src="coachData.avatar" class="pl-coach-avatar" alt="Coach photo" />
      <div v-else class="pl-coach-avatar bg-gray-200 flex align-items-center justify-center flex-shrink-0">
        <span class="text-gray-500 font-semi text-16">{{ initials(coachData) }}</span>
      </div>
      <div class="flex flex-col align-items-start gap-y-xxs" style="min-width: 0;">
        <h2 class="font-semi m-y-none text-16">{{ coachData.full_name }}</h2>
        <span class="pl-badge" :class="status.cssClass" :title="status.title">{{ status.label }}</span>
      </div>
    </div>

    <button type="button" class="btn btn-default btn-compact w-full m-t-sm" data-cy="coach-header-manage" @click="drawerOpen = true">
      {{ isBookable(coachData) ? 'Manage setup' : 'Continue setup' }}
      <i v-if="!isBookable(coachData)" class="fa-solid fa-chevron-right m-l-xxs"></i>
    </button>

    <private-lesson-coach-drawer
      v-if="drawerOpen"
      :coach="coachData"
      :currency="currency"
      :can-edit-pricing="canEditPricing"
      :endpoint="endpoint"
      :access-key="accessKey"
      :cloudfront-base-url="cloudfrontBaseUrl"
      :existing-attachments="coachData.profile_photos || []"
      @close="drawerOpen = false"
      @saved="onDrawerSaved"
    ></private-lesson-coach-drawer>
  </div>
</template>

<script>
import PrivateLessonCoachDrawer from './private_lesson_coach_drawer.vue';
import { coachSetupStatusMix } from './mixins/coach_setup_status_mix';

export default {
  name: 'private-lesson-coach-header',
  components: {
    PrivateLessonCoachDrawer,
  },
  mixins: [coachSetupStatusMix],
  props: {
    coach: {
      type: Object,
      required: true,
    },
    canEditPricing: {
      type: Boolean,
      default: false,
    },
    currency: {
      type: String,
      default: 'usd',
    },
    endpoint: {
      type: String,
      required: true,
    },
    accessKey: {
      type: String,
      required: true,
    },
    cloudfrontBaseUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      // Server-rendered coach JSON, replaced in place after a drawer save so
      // the badge reflects edits without a page reload.
      coachData: _.cloneDeep(this.coach),
      drawerOpen: false,
    };
  },
  computed: {
    status() {
      return this.setupStatus(this.coachData);
    },
  },
  methods: {
    onDrawerSaved() {
      axios.get(this.$apiService.coachUrl(this.coachData.id))
        .then((response) => {
          this.coachData = response.data;
          this.drawerOpen = false;
        })
        .catch(() => {
          // Save succeeded but the refresh failed — reload rather than leave
          // the badge showing stale state.
          window.location.reload();
        });
    },
  },
};
</script>
